import { render, staticRenderFns } from "./DeliveryDetailView.vue?vue&type=template&id=929e86ca&lang=pug&"
import script from "./DeliveryDetailView.vue?vue&type=script&lang=js&"
export * from "./DeliveryDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports